<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Course Execution Plan </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd();" persistent-hint
            hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
            hint="Please Select Standard" />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Division" outlined @change="getCourse" persistent-hint
            hint="Please Select Division" />
        </v-col>
        <v-col sm="2" v-if="crs_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crsid" :items="crs_list"
            item-text="crs_name" label="Subject" outlined @change="getStatus" persistent-hint
            hint="Please Select Subject" />
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="isShow == true">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center ">
                Lecture No.
              </th>
              <th class="text-center ">
                Lecture Date
              </th>
              <th class="text-center ">
                Chapter
              </th>
              <th class="text-center ">
                Concept / Skill / Topic Covered
              </th>
              <th class="text-center ">
                Homework
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredExecutionList" :key="item.id">
              <td class="text-center">{{ item.lesson_no }}</td>
              <td class="text-center">{{ item.execution_date }}</td>
              <td class="text-center">{{ item.chapter }}</td>
              <td class="text-center">{{ item.topic }}</td>
              <td class="text-center">{{ item.homework }}</td>
            </tr>
            <tr v-if="filteredExecutionList.length === 0">
              <td colspan="5" class="text-center grey--text">
                No matching records found
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data() {
    return {
      search: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      isShow: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      show_tt: false,
      std_div_list: null,
      sel_std_data: null,
      crs_plan_execution_list: null,
      div_list: null,
      div: null,
      overlay: false,
      crs_list: null,
      crs: null,
    };
  },
  computed: {
    filteredExecutionList() {
      if (!this.search) return this.crs_plan_execution_list
      const searchLower = this.search.toLowerCase()

      return this.crs_plan_execution_list.filter(item =>
        (item.lesson_no + '').toLowerCase().includes(searchLower) ||
        (item.execution_date + '').toLowerCase().includes(searchLower) ||
        (item.chapter + '').toLowerCase().includes(searchLower) ||
        (item.topic + '').toLowerCase().includes(searchLower) ||
        (item.homework + '').toLowerCase().includes(searchLower)
      )
    }
  },
  methods: {
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = null;
      this.div = null;
      this.div_list = this.sel_std_data.div_list;

      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },



    getCourse() {
      const formData = {
        // ay: this.sel_ay_data,
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
      };
      axios
        .post("/LessonPlanning/getCourse", formData)
        .then((res) => {
          if (res.data.msg == 200) {
            this.crs_list = res.data.crs_list;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    getStatus() {
      //  alert(this.div.div_off_id)
      //  alert(this.sel_std_data.std_id)
      const formData = {
        ay: this.sel_ay_data.ay_id,
        div_off: this.div.div_off_id,
        standard: this.sel_std_data.std_id,
        crs_off: this.crs,
      };
      axios
        .post("/LessonPlanning/getStatus", formData)
        .then((res) => {
          if (res.data.status == "SUCCESS") {
            this.crs_plan_execution_list = res.data.crs_plan_execution_list;
            this.isShow = true;
          }

          else {
            this.showSnackbar("#b71c1c", "Course execution plan not found!!!");
          }
          console.log(crs_plan_execution_list);

        })

        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          console.log(res.data);
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.sel_ay_data;
          // this.std_div_list;
          // this.sel_std_data = null;
          // this.div_list = null;
          // this.div = null;
          for (let index = 0; index < this.ay_std_div_list.length; index++) {
            this.std_div_list = this.ay_std_div_list[index].std_list;
            this.div_list = this.ay_std_div_list[index].std_list.div_list;
          }
          // this.std_div_list = res.data.std_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => { });
    },
  },
  mounted() {
    this.onload();
  },



};
</script>
<style scoped></style>
